import React, { ReactNode, Suspense } from 'react';
import { Route, Redirect, Switch } from 'react-router';
import { BrowserRouter } from 'react-router-dom';
import { SecureRoute } from '@okta/okta-react';
import { OktaAuth } from '@okta/okta-auth-js';
import { PageLoader } from '@cko/dashboard-shared';

import { SecureContainer } from 'auth';
import { sendDatadogAuthEvent } from 'providers';
import { useOktaAuth } from './useOktaAuth';
import { CustomLoginCallback } from './CustomLoginCallback';

const Expired = React.lazy(() => import('./components/Expired'));
const Error = React.lazy(() => import('./components/Error'));

export const ROUTES = {
  home: '/',
  login: '/login',
  expired: '/expired',
};

export const SecureContainerRouter = ({ children }: { children: ReactNode }) => {
  sendDatadogAuthEvent('oldProvider');
  const oktaAuth: OktaAuth = useOktaAuth();

  return (
    <Suspense fallback={<PageLoader />}>
      <BrowserRouter>
        <SecureContainer {...{ oktaAuth }}>
          <Switch>
            <Route path="/implicit/callback" exact>
              <CustomLoginCallback errorComponent={(errProps) => <Error {...errProps} />} />
            </Route>

            <Route path={ROUTES.expired}>
              <Expired />
            </Route>

            <Redirect from={ROUTES.login} to={ROUTES.home} />

            <SecureRoute path={ROUTES.home}>{children}</SecureRoute>
          </Switch>
        </SecureContainer>
      </BrowserRouter>
    </Suspense>
  );
};
